export default __webpack_public_path__ + "static/media/98.85599afb.jpg";